/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Error_Wrong_PasswordInputs */



/**
* | output |
* | --- |
* | "Incorrect password." |
*
* @param {Login_Error_Wrong_PasswordInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const login_error_wrong_password = /** @type {((inputs?: Login_Error_Wrong_PasswordInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Error_Wrong_PasswordInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Mot de passe incorrect.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Falsches Passwort.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Password errata.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Неверный пароль.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Contraseña incorrecta.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("密码错误。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("パスワードが間違っています。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("गलत पासवर्ड।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Senha incorreta.")
	return /** @type {LocalizedString} */ ("Incorrect password.")
});